import Layout from "@/views/layout";

const shopRouter = {
  path: "/shop",
  name: "Advertising",
  component: Layout,
  meta: { title: "门店模块" },
  children: [
    {
      path: "adAudit*",
      name: "AdAudit",
      component: () => import("@/views/shop/adAudit.vue"),
      meta: { title: "广告确认" }
    },
    {
      path: "deal",
      name: "Deal",
      component: () => import("@/views/shop/deal.vue"),
      meta: { title: "协议审核" }
    },
    {
      path: "agreementDetail",
      name: "AgreementDetail",
      component: () => import("@/views/shop/agreementDetail.vue"),
      meta: { title: "协议详情" }
    },
    {
      path: "auditAgain*",
      name: "AuditAgain",
      component: () => import("@/views/shop/auditAgain.vue"),
      meta: { title: "广告缩略图确认" }
    }
  ]
};

export default shopRouter;
